<app-header-page *ngIf="response && response.parent">
    <app-component-button-header-back href="/account/doc/nav/{{response.parent.id}}">
        {{ 'HEADERS.FOLDER' | translate }}: {{ response.parent.name }}
    </app-component-button-header-back>
</app-header-page>
<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div *ngIf="showTabs && response.right.is_edit_settings">
    <div class="super__tabs">
        <div (click)="tab = 'view'; controller.loadNav(pagination)" [class.active]="tab === 'view'"
             [class.disabled_tab]="isPermissionsChanged"
             class="super__tabs tab"
             data-action="view">
            <span>{{ 'DOCUMENTS.TEXT.VIEW' | translate }}</span>
        </div>
        <div (click)="tab = 'access'" [class.active]="tab === 'access'"
             class="super__tabs tab"
             data-action="access">
            <span>{{ 'DOCUMENTS.TEXT.ACCESS' | translate }}</span>
        </div>
    </div>

    <div class="tab__content">
        <div class="tab__content">
            <ng-container *ngIf="tab === 'edit'">
                <ng-container *ngTemplateOutlet="editDocs">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="tab === 'access'">
                <app-documents-access-settings
                        (changeEditEvent)="isPermissionsChanged = $event"
                        [target]="response.folder"
                ></app-documents-access-settings>
            </ng-container>
        </div>
    </div>
</div>

<div *ngIf="tab === 'view'">
    <h1>{{ 'DOCUMENTS.TEXT.COLLECTION' | translate }}</h1>

    <app-component-button-create-fcfv
            [isCollection]="true"
            [isCreateCollection]="isCreateCollection && response.right.is_upload_file && !response.folder.is_locked"
            [isCreateFolder]="false"
    ></app-component-button-create-fcfv>

    <div *ngIf="response && response.folder" class="documents_header p-4 gbo_shadow">
        <h2>{{ 'DOCUMENTS.TEXT.COLLECTION' | translate }}:
            <app-component-input-inline (emitSave)="editCollection('name', $event)"
                                        *ngIf="response.right.is_edit_settings && !response.folder.is_locked"
                                        [editByPen]="true"
                                        [value]="response.folder.name"
            ></app-component-input-inline>
            <span *ngIf="!response.right.is_edit_settings || response.folder.is_locked">{{ response.folder.name }}</span>
        </h2>

        <h2>{{ 'DOCUMENTS.TEXT.DESCRIPTION' | translate }}:</h2>
        <app-component-ckeditor (emitFinish)="editCollection('collection_description', $event[1])"
                                *ngIf="response.right.is_edit_settings && !response.folder.is_locked"
                                [inputData]="response.folder.description"
        ></app-component-ckeditor>
        <div *ngIf="!response.right.is_edit_settings || response.folder.is_locked"
             [innerHTML]="response.folder.description"></div>

        <p>{{ 'DOCUMENTS.TEXT.SIGNED' | translate }}: {{ response.folder.signed_documents }}</p>

        <div class="btn-group p-0">
            <app-visors
                    [collectionId]="response.folder.id"
                    [editPermission]="response.right.is_edit_approver"
                    [typeObj]="'collection'"
            ></app-visors>

            <button (click)="getZipFile()" *ngIf="response" class="btn btn-success"
                    data-action="downloadZIP">
            <span *ngIf="!isLoadingZip else refresh">
                <i class="bi bi-download"></i>
                ZIP
            </span>
            </button>
            <button (click)="blockCollection()"
                    *ngIf="response && response.right.is_locked_collection"
                    [ngbTooltip]="(response.folder.is_locked ? 'DOCUMENTS.TEXT.UNLOCK' : 'DOCUMENTS.TEXT.LOCK') | translate"
                    class="btn btn-light"
                    data-action="blockCollection"
            >
                <i [class]="response.folder.is_locked ? 'bi bi-unlock-fill' : 'bi bi-lock-fill'"></i>
            </button>
            <button (click)="deleteCollection(response)"
                    *ngIf="(response.signed_documents.split('/')[0] !== response.signed_documents.split('/')[1] ||
                    response.signed_documents.split('/')[1] === '0') && !response.folder.is_locked"
                    class="btn btn-danger"
                    data-action="deleteCollection"
            >
                <span *ngIf="!isLockDeleteButton else refresh">
                    <i class="bi bi-trash"></i>
                </span>
            </button>
        </div>
    </div>

    <div class="documents_body">
        <app-component-folder-and-file-table
                (eventClick)="onEventTrClick($event)"
                (eventFind)="onEventFind($event)"
                [$mediator]="controller.$mediator"
        ></app-component-folder-and-file-table>
    </div>
</div>

<ng-template #editDocs>
    collection
</ng-template>
